import { Box, Button, Typography } from "@mui/material";
import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

import Weaknesses from "../../../../components/charts/Weakness";
import DiscoverdAssetsTable from "../../../../components/charts/DiscoverdAssetsTable";

import { useSelector } from "react-redux";

export default function DiscoveredAssets() {
  const dashboardData = useSelector((state) => state.dashboard.jsonData);

  const discoveredAssetsData = dashboardData?.discovered_assets || [];

  const history = useHistory();
  function handlGoBack() {
    history.goBack();
  }

  const chartData = discoveredAssetsData.map((item) => ({
    Title: item.category, // Use 'category' as the label
    Count: item.avg_asset_value, // Use 'avg_asset_value' as the value
  }));

  return (
    <Box sx={{ marginBottom: { xs: "25%" } }}>
      <Button
        sx={{
          background: "#78c3ae",
          borderRadius: 4,
          fontSize: "16px",
          marginLeft: { xs: "8px", sm: "5px" }, // Remove marginLeft on mobile
          alignSelf: "flex-start",

          "&:hover": {
            backgroundColor: "#60dbb9",
          },
        }}
        onClick={handlGoBack}
      >
        <ArrowBackIcon sx={{ color: "white" }} />
      </Button>
      <Typography sx={{ textAlign: "center", fontSize: "40px" }}>
        Discovered Assets
      </Typography>

      {/* top pie */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "center",
          alignItems: "center",
          gap: { xs: 2, sm: 4 },
          mt: 4,
          px: { xs: 1, sm: 2 },
        }}
      >
        <Box
          sx={{
            boxShadow: 3,
            borderRadius: 2,
            p: { xs: 2, sm: 3 },
            bgcolor: "background.paper",
            width: { xs: "90%", sm: "90%", md: "90%" },
            minHeight: "100px",
            height: "auto",
            textAlign: "center",
          }}
        >
          <Weaknesses
            data={chartData} // Pass the transformed data
            type="pie" // You can change this to "pie" if desired
            title="Average Asset Value by Category"
          />
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "center",
          alignItems: "center",
          gap: { xs: 2, sm: 4 },
          mt: 4,
          px: { xs: 1, sm: 2 },
        }}
      >
        <Box
          sx={{
            boxShadow: 3,
            borderRadius: 2,
            p: { xs: 2, sm: 3 },
            bgcolor: "background.paper",
            width: { xs: "90%", sm: "90%", md: "90%" },
            minHeight: "100px",
            height: "auto",
            textAlign: "center",
          }}
        >
          <DiscoverdAssetsTable data={discoveredAssetsData} />
        </Box>
      </Box>
    </Box>
  );
}
